export function renderSuositeltavatLisatutkimukset({
  content,
  data,
}) {
  const items = data?.items || [];

  // Title
  content.push({
    text: "Suositeltavat lisätutkimukset:",
    style: "paragraph",
    bold: true,
    margin: [0, 10, 0, 6],
  });

  // If no items or all empty
  if (
    !items.length ||
    items.every((it) => !it.text || !it.text.trim())
  ) {
    content.push({
      ul: ["Ei toimenpiteitä."],
      margin: [15, 0, 0, 10],
    });
    return;
  }

  // Normal bullet list
  content.push({
    ul: items
      .filter((it) => it.text?.trim())
      .map((it) => it.text),
    margin: [15, 0, 0, 10],
  });
}
